// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1bymg","subheader":"ReorderModal_subheader__jVF-M","listWrap":"ReorderModal_listWrap__3m0Y9"};